module.exports = __webpack_public_path__ + "img/Icon awesome-map-marker-alt.cf07bfe5.svg";